// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__1Snpx","bigColWidth":"Table_bigColWidth__1KrC_","biggerColWidth":"Table_biggerColWidth__15JcP","row":"Table_row__2Iez5","col":"Table_col__wL5Xf"};